<template>
  <div class="page">
    <h1>Impressum</h1>
    <p>TODO</p>
  </div>
</template>

<script>
export default {
  data: () => ({ hasIds: false, hasRegister: false })
}
</script>

<style scoped>
.page{max-width:900px;margin:40px auto;padding:0 16px;color:#fff}
h1{margin-bottom:16px}
.note{opacity:.8;margin-top:16px}
</style>
